import React from 'react';

function getDesign(param) {
    const {M012_remPassword, setCheckboxFlg} = param;

    return (
        <div className="buttonWrap__check">
            <label className="ds-checkbox">
                <input className="ds-checkbox__input" type="checkbox" id="LB_form-checkbox-02" name="checkLogin" onClick={(e) => setCheckboxFlg(e.target.checked)} />
                <span className="ds-checkbox__partsWrap">
                    <span className="ds-checkbox__parts" role="presentation"></span>
                    <span className="ds-checkbox__text">{M012_remPassword}</span>
                </span>
            </label>
        </div>
    );
}

export {getDesign}
